import { Box, CircularProgress, styled, Typography } from "@mui/material";

const StyledLoading = styled("div")({
  width: "100%",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(135deg, #0f0c29, #302b63, #24243e)",
  gap: "20px",
});

const LogoBox = styled(Box)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const LogoMark = styled(Box)({
  width: 64,
  height: 64,
  borderRadius: 18,
  background: "linear-gradient(135deg, #667eea, #764ba2)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 8px 32px rgba(102,126,234,0.5)",
});

export default function MatxLoading() {
  return (
    <StyledLoading>
      <LogoBox>
        <CircularProgress
          size={84}
          thickness={1.5}
          sx={{
            position: "absolute",
            color: "rgba(102,126,234,0.5)",
            animationDuration: "1.6s",
          }}
        />
        <LogoMark>
          <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: 28 }}>
            D
          </Typography>
        </LogoMark>
      </LogoBox>
      <Typography
        sx={{
          color: "rgba(255,255,255,0.5)",
          fontSize: "0.8125rem",
          letterSpacing: 2,
          textTransform: "uppercase",
        }}
      >
        Loading...
      </Typography>
    </StyledLoading>
  );
}
